export const parseCellId = (cellId) => {
  const col = cellId.charCodeAt(0) - 64;
  const row = parseInt(cellId.slice(1), 10);
  return [col, row];
};

export const createCellId = (col, row) => {
  return `${String.fromCharCode(64 + col)}${row}`;
};
